const TTL_MS = 5 * 60 * 1e3;
let at = 0;
let ok = false;
let cachedForToken = "";
export function tokenCheckFresh(currentToken) {
    if (!currentToken || currentToken !== cachedForToken)
        return false;
    return ok && Date.now() - at < TTL_MS;
}
export function setTokenCheckResult(success, token) {
    at = Date.now();
    ok = !!success;
    cachedForToken = token || "";
}
export function clearTokenCheckCache() {
    ok = false;
    at = 0;
    cachedForToken = "";
}
